import { EERIE } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalNotEnabledStep = props => {
  const {
    iconName,
    text
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: "align-center m-bottom-3",
    children: [/*#__PURE__*/_jsx("div", {
      className: "justify-center align-center no-shrink",
      style: {
        borderRadius: '50%',
        backgroundColor: EERIE,
        height: '40px',
        width: '40px'
      },
      children: /*#__PURE__*/_jsx(UIIcon, {
        color: "white",
        name: iconName,
        size: 18
      })
    }), /*#__PURE__*/_jsx("span", {
      className: " m-left-3 text-left",
      children: text
    })]
  });
};
export default ApprovalNotEnabledStep;